import { trans } from './trans';

export const getTranslatedSection = (sectionCurriculumSlug: string) => {
    switch (sectionCurriculumSlug) {
        case 'english':
            return trans('i-want-to-learn-english', {}, 'student-registration');
        case 'business-english':
            return trans('i-want-to-learn-business-english', {}, 'student-registration');
        case 'german':
            return trans('i-want-to-learn-german', {}, 'student-registration');
        case 'spanish':
            return trans('i-want-to-learn-spanish', {}, 'student-registration');
        case 'french':
            return trans('i-want-to-learn-french', {}, 'student-registration');
        case 'italian':
            return trans('i-want-to-learn-italian', {}, 'student-registration');
        default:
            return '';
    }
};
